import React from 'react';
import HeaderRow from './HeaderRow';
import Row from './Row';

class ZTable extends React.Component {
    // Build Standard Normal Table
    render() {
        const Rows = this.props.table.map((numbers, index) => {
            // Build Header Row of hundredths place z-scores
            if (index === 0) {
                return (
                    <HeaderRow
                        key={index - 1}
                        values={numbers}
                    />
                );
            }
            // Build Z-value Rows where first cell will be HeaderCell holding part of z-score
            else {
                return (
                    <Row
                        key={index - 1}
                        numbers={numbers}
                        flags={this.props.flags[index - 1]}
                    />
                );
            }
        });

        // Build All Rows
        return (
            <div className="tableWrapper">
                <table>
                    <tbody>
                        {Rows}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ZTable;